<ng-template #inputErrorGeneral let-error>
  <ng-container *ngIf="showErrors && error !== null">
    <mat-error>
      {{ error }}
    </mat-error>
  </ng-container>
</ng-template>

<ng-template #episodeShowDetailFields>
  
</ng-template>

<div class="episode-general-content container ">
  <div class="row">
    <div class="col-lg-6">
      <div class="row">
        <div class="col-lg-12">
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: errors.showName }"
            [ngTemplateOutlet]="inputErrorGeneral"
          ></ng-container>
          <mat-form-field appearance="fill">
            <mat-label>Program Name*</mat-label>
            <input
              matInput
              (ngModelChange)="onViewDataChange()"
              [(ngModel)]="viewData.showName"
              placeholder="Program Name"
              data-testid="epg-episode-show-name-input"
              type="text"
            />
          </mat-form-field>          
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: errors.title }"
            [ngTemplateOutlet]="inputErrorGeneral"
          ></ng-container>
          <mat-form-field appearance="fill">
            <mat-label>Title*</mat-label>
            <input
              matInput
              (ngModelChange)="onViewDataChange()"
              [(ngModel)]="viewData.title"
              placeholder="Title"
              data-testid="epg-episode-title-input"
              type="text"
            />
          </mat-form-field>         
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: errors.description }"
            [ngTemplateOutlet]="inputErrorGeneral"
          ></ng-container>
          <mat-form-field appearance="fill">
            <mat-label>Description*</mat-label>
            <textarea
              matInput
              (ngModelChange)="onViewDataChange()"
              [(ngModel)]="viewData.description"
              placeholder="Description"
              data-testid="epg-episode-description-input"
            ></textarea>
          </mat-form-field>          
        </div>
      </div>
      <div class="row">     
        <div class="col-lg-6">
          <app-episode-thumbnail-input
            #showThumbnailInput
            title="Show Card"
            [thumbnail]="viewData.thumbnails.show"
            tootipPlacementImageUrl="sample_show-card.png"
            (onChange)="onChangeShowThumbnail($event)"
          ></app-episode-thumbnail-input>
        </div>
        <div class="col-lg-6">
          <app-episode-thumbnail-input
            #titleThumbnailInput
            title="Thumbnail"
            [thumbnail]="viewData.thumbnails.title"
            tootipPlacementImageUrl="sample_thumbnail.png"
            (onChange)="onChangeTitleThumbnail($event)"
          ></app-episode-thumbnail-input>
        </div>
      </div>
    </div>
    <div class="col-lg-6">      
      <div class="row">
        <div class="col">
          <ng-container
            [ngTemplateOutletContext]="{ $implicit: errors.quality }"
            [ngTemplateOutlet]="inputErrorGeneral"
          ></ng-container>
           <ng-container
            [ngTemplateOutletContext]="{ $implicit: errors.viewerRating }"
            [ngTemplateOutlet]="inputErrorGeneral"
          ></ng-container>
        </div>      
      </div>
      <div class="row">
        <div class="col-lg-4 px-1">
          <mat-form-field appearance="fill">
            <mat-label>Quality</mat-label>
            <mat-icon matSuffix>expand_more</mat-icon>
            <mat-select
              placeholder="Quality"
              data-testid="epg-episode-quality-select"
              (ngModelChange)="onViewDataChange()"
              [(ngModel)]="viewData.quality"
            >
              <ng-container *ngFor="let q of quality">
                <mat-option
                  data-testid="epg-episode-quality-option"
                  [value]="q.value"
                >
                  {{ q.label }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
         
        </div>
        <div class="col-lg-4 px-1">
          <mat-form-field appearance="fill">
            <mat-label>Rating</mat-label>
            <mat-icon matSuffix>expand_more</mat-icon>
            <mat-select
              placeholder="Rating"
              data-testid="epg-episode-quality-select"
              (ngModelChange)="onViewDataChange()"
              [(ngModel)]="viewData.viewerRating"
            >
              <ng-container *ngFor="let r of raitings">
                <mat-option
                  data-testid="epg-episode-quality-option"
                  [value]="r.value"
                >
                  {{ r.label }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>         
        </div>
        <div class="col-lg-4 px-1">
          <mat-slide-toggle (change)="toggleClosedCaptions($event)"  [checked]="this.viewData.showDetails.closedCaptions" data-testId="epg-toggle-button">
            <span>Closed Captions</span>
          </mat-slide-toggle>
        </div>      
      </div>
      <div class="row episode-general-extra-details-wrapper">
        <div class="episode-general-extra-details-container">
          <div class="episode-general-extra-details-title">
           <span>Extra Details</span> 
          </div>
          <div class="episode-general-extra-details-button">
            <button 
              mat-icon-button 
              (click)="$event.stopPropagation()"
              [matMenuTriggerFor]="menu"
            >
              <mat-icon class="material-symbols-outlined">add_circle</mat-icon>
              <mat-icon matSuffix>expand_more</mat-icon>
            </button>
            <mat-menu #menu="matMenu" overlayPanelClass="details-list" xPosition="before">
              <button 
                *ngFor="let extraDetail of extraDetailsList; let i = index"
                (click)="onChangeExtraDetails(i)"
                class="episode-general-extra-details-button-item"
                [ngClass]="{'active': extraDetail.value}"
                mat-menu-item
              >
                <span>{{extraDetail.label}}</span>
              </button>
            </mat-menu>
          </div>
          <div *ngIf="!onAnyExtraDetail()" class="episode-general-extra-details-placeholder">
            <span>
              Please use the add icon above to add extra fields
            </span>
          </div>
          <div *ngIf="onAnyExtraDetail()" class="container episode-general-extra-details-content">
            <div class="row" *ngIf="onExtraDetailLabelActive('Season')">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>Season</mat-label>
                  <input
                    matInput
                    placeholder="Season"
                    data-testid="epg-episode-show-details-season-input"
                    (ngModelChange)="onViewDataChange()"
                    [(ngModel)]="viewData.showDetails.seasonNumber"
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 pt-2">
                <button (click)="onChangeExtraDetailsByLabel('Season')" mat-icon-button class="episode-general-extra-details-delete-button">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="row" *ngIf="onExtraDetailLabelActive('Episode')">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>Episode</mat-label>
                  <input
                    matInput
                    placeholder="Episode"
                    data-testid="epg-episode-show-details-episode-input"
                    (ngModelChange)="onViewDataChange()"
                    [(ngModel)]="viewData.showDetails.episodeNumber"
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 pt-2">
                <button (click)="onChangeExtraDetailsByLabel('Episode')" mat-icon-button class="episode-general-extra-details-delete-button">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="row" *ngIf="onExtraDetailLabelActive('Year')">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>Year</mat-label>
                  <input
                    matInput
                    placeholder="Year"
                    data-testid="epg-episode-show-details-year-input"
                    (ngModelChange)="onViewDataChange()"
                    [(ngModel)]="viewData.showDetails.year"
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 pt-2">
                <button (click)="onChangeExtraDetailsByLabel('Year')" mat-icon-button class="episode-general-extra-details-delete-button">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="row" *ngIf="onExtraDetailLabelActive('League')">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>League</mat-label>
                  <input
                    matInput
                    placeholder="League"
                    data-testid="epg-episode-show-details-league-input"
                    (ngModelChange)="onViewDataChange()"
                    [(ngModel)]="viewData.showDetails.league"
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 pt-2">
                <button (click)="onChangeExtraDetailsByLabel('League')" mat-icon-button class="episode-general-extra-details-delete-button">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="row" *ngIf="onExtraDetailLabelActive('Cast')">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>Cast</mat-label>
                  <input
                    matInput
                    placeholder="Cast"
                    data-testid="epg-episode-show-details-cast-input"
                    (ngModelChange)="onViewDataChange()"
                    [(ngModel)]="viewData.showDetails.cast"
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 pt-2">
                <button (click)="onChangeExtraDetailsByLabel('Cast')" mat-icon-button class="episode-general-extra-details-delete-button">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
            <div class="row" *ngIf="onExtraDetailLabelActive('Host')">
              <div class="col">
                <mat-form-field appearance="fill">
                  <mat-label>Host</mat-label>
                  <input
                    matInput
                    placeholder="Host"
                    data-testid="epg-episode-show-details-host-input"
                    (ngModelChange)="onViewDataChange()"
                    [(ngModel)]="viewData.showDetails.host"
                    type="text"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 pt-2">
                <button (click)="onChangeExtraDetailsByLabel('Host')" mat-icon-button class="episode-general-extra-details-delete-button">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
          
        </div>
      </div>      
    </div>
  </div>
</div>   